import {OnDestroy} from '@angular/core';
import {AfterViewInit} from '@angular/core';
import {signal} from '@angular/core';
import {computed} from '@angular/core';
import {AgCharts} from 'ag-charts-angular';
import {v4 as uuidv4} from 'uuid';
import {Subscription} from 'rxjs';
import {Component} from '@angular/core';
import {EventBusService} from '../../../../core/base/angular/client/services/EventBusService/EventBusService';
import {inject} from '@angular/core';
import {DynamicData} from '../../../../core/base/angular/client/DynamicData/DynamicData';
@Component({
	selector:'sample-revenue-chart',
	templateUrl:'./SampleRevenueChart.html',
	styles: [`:host { display: block; position: relative; width:100%;height:100% }`
],
	styleUrls:['./SampleRevenueChart.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		AgCharts,
],
	standalone:true
})
export class SampleRevenueChart implements OnDestroy,AfterViewInit
{
	readonly eventBusService = inject(EventBusService);
	readonly chartOptions = signal<any | undefined>(undefined);
	readonly handlerId : string;
	private subscriptionOptions?: Subscription;
	private subscriptionData?: Subscription;
	chartData: any; // optional separate data payload;
	readonly chartReady = computed(()=>!!this.chartOptions());
	readonly listenerName = 'revenueChart';
	readonly clazzName = 'com.jwebmp.website.pages.home.SampleRevenueChart';
	constructor( )
	{
		this.handlerId = this.generateHandlerId();
	}
	ngAfterViewInit()
	{
		this.initializeOptionsListener(); this.initializeDataListener(); this.fetchOptions(); this.fetchDataChannel();
	}
	initializeOptionsListener() {
	  const observer = {
	    next: (data: any) => this.handleOptionsEvent(data),
	    error: (err: any) => console.error('[AgChart] options listener error:', err),
	    complete: () => console.log('[AgChart] options listener completed'),
	  };
	  this.subscriptionOptions = this.eventBusService
	    .listen(this.listenerName + 'Options', this.handlerId)
	    .subscribe(observer);
	}
	handleOptionsEvent(data: any) {
	  try {
	    const payload = typeof data === 'string' ? JSON.parse(data) : data;
	    // Some servers wrap in { out: [...] }
	    const options = payload && payload.out && payload.out[0] ? payload.out[0] : payload;
	    this.chartOptions.set(options);
	  } catch (e) {
	    console.error('[AgChart] Failed to parse options payload', e, data);
	  }
	}
	fetchOptions() {
	  this.eventBusService.send(this.listenerName + 'Options', {
	    className: this.clazzName,
	    listenerName: this.listenerName + 'Options'
	  }, this.listenerName + 'Options');
	}
	initializeDataListener() {
	  const observer = {
	    next: (data: any) => this.handleDataEvent(data),
	    error: (err: any) => console.error('[AgChart] data listener error:', err),
	    complete: () => console.log('[AgChart] data listener completed'),
	  };
	  this.subscriptionData = this.eventBusService
	    .listen(this.listenerName + 'Data', this.handlerId)
	    .subscribe(observer);
	}
	handleDataEvent(data: any) {
	  try {
	    const payload = typeof data === 'string' ? JSON.parse(data) : data;
	    const value = payload && payload.out && payload.out[0] ? payload.out[0] : payload;
	    this.chartData = value;
	    const current = this.chartOptions();
	    if (!current) { return; }
	    let updated;
	    if (Array.isArray(current.series) && current.series.length > 0) {
	      // Common case: first series data
	      updated = { ...current, series: [ { ...current.series[0], data: value }, ...current.series.slice(1) ] };
	    } else {
	      // Fallback: place on options.data
	      updated = { ...current, data: value };
	    }
	    this.chartOptions.set(updated);
	  } catch (e) {
	    console.error('[AgChart] Failed to parse data payload', e, data);
	  }
	}
	fetchDataChannel() {
	  this.eventBusService.send(this.listenerName + 'Data', {
	    className: this.clazzName,
	    listenerName: this.listenerName + 'Data'
	  }, this.listenerName + 'Data');
	}
	private generateHandlerId(): string {
	    return `${this.listenerName}-${uuidv4()}`;
	}

	ngOnDestroy()
	{
		this.subscriptionOptions?.unsubscribe(); this.subscriptionData?.unsubscribe(); this.eventBusService.unregisterListener(this.listenerName + 'Options', this.handlerId); this.eventBusService.unregisterListener(this.listenerName + 'Data', this.handlerId);
	}
}
